import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { BoardPerson, UUID } from "@/lib/types";

/**
 * Everyone who can appear in a board's person cells — workspace members PLUS
 * cross-department guests. Person cells resolve avatars/names from this; the
 * workspace-members list alone can't render guests (they aren't members).
 */
export function useBoardPeople(boardId: UUID | undefined) {
  return useQuery<BoardPerson[]>({
    enabled: Boolean(boardId),
    queryKey: boardId ? ["boards", boardId, "people"] : ["boards", "void", "people"],
    queryFn: () => api.listBoardPeople(boardId as UUID),
    staleTime: 5 * 60_000,
  });
}
